import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-logo-clang-format-config-migrate-inline',
  standalone: true,
  templateUrl: '../../assets/img/logo-clang-format-config-migrate.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoClangFormatConfigMigrateInlineComponent { }
